import { CtaButton } from '@tkww/orion-web-ds-action';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import TrackableContainer from '../../../components/shared/TrackableContainer';
import {
	ARTICLES,
	CATEGORY_LANDING_PAGE,
	WIDGET_VIEWED,
} from '../../../utils/tracking';
import { Article } from './Article';
import { articles } from './config';

import { GridRow } from '@tkww/orion-web-ds-structure';
import ClientStyles from '../../../styles.scss';
import Styles from './styles.scss';

export class Articles extends PureComponent {
	static propTypes = {
		category: PropTypes.shape({
			categoryCode: PropTypes.string.isRequired,
			categoryName: PropTypes.string.isRequired,
		}).isRequired,
	};

	viewedAnalytics() {
		return {
			event: WIDGET_VIEWED,
			properties: {
				sourceContent: ARTICLES,
				sourcePage: CATEGORY_LANDING_PAGE,
				vendorCategoryCode: this.props.category.categoryCode,
			},
		};
	}

	render() {
		const { categoryName, categoryCode } = this.props.category;
		const { articles: categoryArticles, categoryLink } = articles[categoryCode];

		return (
			<TrackableContainer trackingData={this.viewedAnalytics()}>
				<div id="articles" className={Styles.outerContainer}>
					<div className={Styles.articleContainer}>
						<div className={Styles.articleSectionHeader}>
							<h2
								className={Styles.title}
							>{`${categoryName}: Ideas & Advice`}</h2>

							<div className={ClientStyles.hideBlockOnMobile}>
								<CtaButton
									size="md"
									styleType="secondary-alternative"
									href={categoryLink}
									as="a"
									treatAs="link"
								>
									Get More Advice
								</CtaButton>
							</div>
						</div>

						<GridRow>
							{categoryArticles.map((article) => (
								<Article
									article={article}
									category={this.props.category}
									categoryLink={categoryLink}
									key={article.srcId}
								/>
							))}
						</GridRow>

						<div className={ClientStyles.hideOnDesktop}>
							<CtaButton
								size="md"
								className={Styles.readMoreMobile}
								styleType="secondary-alternative"
								href={categoryLink}
								as="a"
								treatAs="link"
							>
								Get More Advice
							</CtaButton>
						</div>
					</div>
				</div>
			</TrackableContainer>
		);
	}
}
